<template>
  <div>
    <div v-if="loading" class="text-center">
      <div class="spinner-border text-center" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div class="text-center">
        <img class="mb-3 logo" :src="logo">
      </div>
      <div class="user-info">
        <h2>Payment process</h2>
        <p>
          <strong>Client Name:</strong> {{info.clientFirstName}} {{info.clientLastName}}<br>
          <strong>Reservation:</strong> #{{info.reservationId}}<br>
          <strong>Total to pay:</strong> ${{info.total}} {{info.currency}}
        </p>
      </div>
    </div>
    <div :class="loading?'d-none':''">
      <div id="card-element"></div>
      <div id="card-errors" role="alert">{{error}}</div>
      <div class="text-center" >
        <button @click="checkout" class="mt-3 btn btn-primary btn-block">PAY</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Stripe',
	components: {},
  props: {
  },
  data: () => {
    return {
      stripe:null,
      elements:null,
      card : null,
      loading: true,
      info: {},
      error : '',
      clientSecret: null
    }
  },
  mounted() {
    this.stripe = Stripe(this.stripeKey);
    this.elements = this.stripe.elements();
    this.card = this.elements.create("card",{style:this.stripeStyles});
    this.card.mount("#card-element");

    this.card.on('change', ({error}) => {
      if (error) {
        this.error = error.message
      } else {
        this.error = ''
      }
    });

    this.$http.get('payments/s-intent', {params: {token: this.$route.query.token}}).then((res) => {
      const body = res.body;
      if (!body || !body.clientSecret) {
        throw new Error();
      }

      this.clientSecret = body.clientSecret
      this.info = res.body;
      this.loading = false
    }).catch((e) => {
      console.log('err', e);
      this.$router.push('error');
    });
  },
  methods: {
    checkout() {
      this.loading = true
      this.stripe.confirmCardPayment(this.clientSecret, {
        payment_method: {
          card: this.card
        }
      }).then( (result) => {
        if (result.error) {
          // Show error to your customer (e.g., insufficient funds)
          this.error = result.error.message
          this.loading = false
        } else {
          // The payment has been processed!
          if (result.paymentIntent.status === 'succeeded') {
            this.$http.get('payments/s-intent-update', {params: {token: this.$route.query.token}}).then((res) => {
              this.$router.push('success');
            });
            // Show a success message to your customer
            // There's a risk of the customer closing the window before callback
            // execution. Set up a webhook or plugin to listen for the
            // payment_intent.succeeded event that handles any business critical
            // post-payment actions.
          }else{
            this.loading = false
          }
        }
      });
      // this.$refs.elementsRef.submit();
      // this.loading = true
      // this.$http.get('payments/execute-payment', {
      //   params: {token: this.$route.query.token}
      // }).then((res) => {
      //   if (res.body && res.body.success) {
      //     this.$router.push('success');
      //   }
      // }).catch(() => {
      //   console.log('err', e);
      //   this.$router.push('error');
      // });
    }
  },
  computed: {
    stripeKey(){
      return this.settings.paymentTypes.find(pm => pm.code == 'stripe').publicKey
    },
    stripeStyles(){
      return {
        base:{
        }
      }

    },
    ...mapState(['hasSetting', 'settings']),
    logo() {
      if (this.hasSetting) {
        return this.settings.logo;
      }
      return 'https://api.btransfer.mx/uploads/btransfer-logo.png';
    }
  },
}
</script>

<style scoped>
  .logo{
		max-width: 200px;
  }
</style>
<style scoped>
#card-errors{
  text-align: center;
  font-size: 18px;
  margin-top: 10px;
  color: red;
}
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
